import UserSettings from './UserSettings';

const UserSettingsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/usersettings',
			element: <UserSettings />
		}
	]
};

export default UserSettingsConfig;
